import { makeAutoObservable, runInAction } from 'mobx';

import MessagesService from './MessagesService';
import { MessageForm } from './forms/MessageForm';
import MessagesListItemModel from './models/MessagesListItemModel';

export class MessagesStore {
  list: MessagesListItemModel[] = [];
  listLoading = false;
  listLoaded = true;

  createMessageLoading: boolean = false;
  deleteMessageLoading: boolean = false;

  private service: MessagesService;

  constructor() {
    makeAutoObservable(this);
    this.service = new MessagesService();
  }

  // API

  getList = (documentTypeId: number, documentId: number) => {
    this.listLoading = true;

    void this.service
      .getList(documentTypeId, documentId)
      .then((data) =>
        runInAction(() => {
          this.list = data;
          this.listLoaded = true;
        }),
      )
      .catch(() =>
        runInAction(() => {
          this.listLoaded = false;
        }),
      )
      .finally(() =>
        runInAction(() => {
          this.listLoading = false;
        }),
      );
  };

  createMessage = (documentTypeId: number, documentId: number, form: MessageForm) => {
    this.createMessageLoading = true;

    this.service
      .createMessage(documentTypeId, documentId, form)
      .then((data) =>
        runInAction(() => {
          this.list = data;
        }),
      )
      .catch(() => {})
      .finally(() =>
        runInAction(() => {
          this.createMessageLoading = false;
        }),
      );
  };

  deleteMessage = (documentTypeId: number, documentId: number, messageId: number) => {
    this.deleteMessageLoading = true;

    this.service
      .deleteMessage(documentTypeId, documentId, messageId)
      .then((data) =>
        runInAction(() => {
          this.list = data;
        }),
      )
      .catch(() => {})
      .finally(() =>
        runInAction(() => {
          this.deleteMessageLoading = false;
        }),
      );
  };

  resetList = () => {
    this.list = [];
    this.listLoading = false;
    this.listLoaded = true;
  };
}
